import React from 'react'

export const Footer = () => {
    return (
        <div className='footer-spingo-private'>
            © {new Date().getFullYear()}  SpinGo. Todos los derechos reservados.
        </div>
    )
}
